// Where each notify page lives. The staff section is under /admin/notify;
// the organization's own delivery view under /org/notification-activity.
export const NOTIFY_BASE = '/admin/notify'
export const ORG_ACTIVITY_BASE = '/org/notification-activity'

// A notification's timeline (id = the trace id, or an outbox id).
export const timelinePath = (traceID, system = true) =>
  `${system ? NOTIFY_BASE : ORG_ACTIVITY_BASE}/timeline/${encodeURIComponent(traceID)}`

// The capture viewer, open on one capture (?capture=<id>: a query
// parameter, so the list stays drawn under its panel).
export const CAPTURE_PARAM = 'capture'
export const capturePath = captureID => `${NOTIFY_BASE}/captures?${CAPTURE_PARAM}=${encodeURIComponent(captureID)}`

// The Rollout tab, open on one switch (#<key>, e.g. #type:course.published).
export const rolloutPath = key => `${NOTIFY_BASE}/rollout${key ? `#${key}` : ''}`
